import type { ReactNode } from "react"

/** One sidebar block: height follows content, does not shrink or overlap siblings. No margin/padding on the wrapper. */
export function Row(input: { children: ReactNode }) {
  return <div className="sidebar__row">{input.children}</div>
}
